// extracted by mini-css-extract-plugin
module.exports = {"searchLabel":"searchLabel_searchLabel__YUw7Y","black":"searchLabel_black__14UtE","white":"searchLabel_white__E1pLE","srOnly":"searchLabel_srOnly__UbDvt"};